export default {
  id: "fa489626-9ffb-4e1b-9c72-69d436c1fbb7",
  icon: "mdi-message-question",
  name: "contentMultipleChoiceQuestion",
  title: "Multiple Choice Question",
  description: "A block with content from library",
};
